import { accountsFilterAtom } from 'atoms/filters/rsim-products';
import { accountsHintsAtom } from 'atoms/hints/rsim-products';
import { AccountSearchFilter } from 'common/components/Filters/Inputs/accounts/AccountSearchFilter';

export const AccountSearchInput = () => {
  return (
    <AccountSearchFilter
      accountsFilterAtom={accountsFilterAtom}
      accountsHintsAtom={accountsHintsAtom}
    />
  );
};
